<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'债权融资申请审核'}]" :title="'债权融资申请审核'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待更进" name="1" v-if="authorities.indexOf('sys:permission:background:debt:apply:unAudit')!=-1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2" v-if="authorities.indexOf('sys:permission:background:debt:apply:audit')!=-1"></el-tab-pane>
            </el-tabs>
            
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果</span>
                        <el-select v-model="sendInfoOne.checkStatus" placeholder="请选择" size="small" clearable>
                            <el-option :value="void 0" label="全部" />
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value" >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child" v-show="tab==='2'">
                        <span class="name">放款进度</span>
                        <el-select v-model="sendInfoOne.rate" placeholder="请选择" size="small" clearable>
                            <el-option :value="void 0" label="全部" />
                            <el-option :value="0" label="放款中" />
                            <el-option
                            v-for="item in proList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value" >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                        	value-format="yyyy-MM-dd HH:mm:ss"
                        	type="datetimerange" 
                        	:default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width:250px;">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable style="width:150px;"></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==='1'"
                :data="tableData"
                ref="multipleTable"
                @sort-change="sortChange"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="债权产品名称">
                    <template slot-scope="scope">
                        <div class="tableName" @click="viewDetails(scope.row)">{{scope.row.debtProductName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
				v-if="authorities.indexOf('sys:permission:background:debt:apply:unAudit:button:view')!=-1||authorities.indexOf('sys:permission:background:debt:apply:unAudit:button:audit')!=-1"
                    label="操作"
                    
                    width="300">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:debt:apply:unAudit:button:view')!=-1">查看</el-button>
                        <el-button :disabled="scope.row.bankCheckStatus !== 0" size="small" type="primary" class="super" plain @click="audit(scope.row)"
                        v-if="authorities.indexOf('sys:permission:background:debt:apply:unAudit:button:audit')!=-1">更改审核</el-button>
                        <el-button size="small" :disabled="scope.row.bankCheckStatus!== 1" type="primary" class="super" plain @click="update(scope.row)"
                               v-if="authorities.indexOf('sys:permission:background:debt:apply:unAudit:button:audit')!=-1">更新进度</el-button>
                                   
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==='2'"
                ref="table"
                :data="tableData"
                @sort-change="sortChange"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    label="姓名">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="产品名称">
                    <template slot-scope="scope">
                        <div class="tableName ellipsis" @click="viewDetails(scope.row)">{{scope.row.debtProductName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable="custom"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    label="审核人">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    sortable="custom"
                    label="更新时间">
                </el-table-column>
                <el-table-column
                    prop="bankCheckStatusValue"
                    show-overflow-tooltip
                    label="银行审核结果">
                    <template slot-scope="{row}">
                        <div :style="`color:${row.bankCheckStatus === 0?'#1069DD':row.bankCheckStatus === -1?'#F64B4B':'#39BD06'}`">{{row.bankCheckStatusValue}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="checkStatusValue"
                    show-overflow-tooltip
                    label="平台审核结果">
                    <template slot-scope="{row}">
                        <div :style="`color:${row.checkStatus === 0?'#1069DD':row.checkStatus === -1?'#F64B4B':'#39BD06'}`">{{row.checkStatusValue}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="rateValue"
                    show-overflow-tooltip
                    label="放款进度">
                    <template slot-scope="{row}">
                        <div :style="`color:${row.rate === 0?'#1069DD':row.rate === -1?'#F64B4B':'#39BD06'}`">{{row.rateValue}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:debt:apply:audit:button:view')!=-1">查看</el-button>
                                   <el-button size="small" type="primary" class="super" plain @click="updateProd(scope.row)" v-if="authorities.indexOf('sys:permission:background:debt:check:change')!=-1" v-show="scope.row.rate === -1 || scope.row.bankCheckStatus === -1">更换产品</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="sendInfoOne.currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看表格详情 -->
            <el-dialog
                title="债权产品信息"
                :visible.sync="dialogDetail"
                width="50%">
                <div class="basic">
                    <div class="child">
                        <div class="name">银行名称：</div>
                        <div class="content">{{detail.bankName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">产品名称：</div>
                        <div class="content">{{detail.debtProductName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">贷款类型：</div>
                        <div class="content">{{detail.loanTypeValue}}</div>
                    </div>
                    <div class="child">
                        <div class="name">最高额度：</div>
                        <div class="content">{{detail.maxAmount}}</div>
                    </div>
                    <div class="child">
                        <div class="name">最低额度：</div>
                        <div class="content">{{detail.minAmount}}</div>
                    </div>
                    <div class="child">
                        <div class="name">担保方式：</div>
                        <div class="content">
						{{detail.guaranteeWayValue}}
						<span v-for="(i,index) in detail.guaranteeWay" :key="index">{{i.value}} </span>
						</div>
                    </div>
                    <div class="child">
                        <div class="name">年利率：</div>
                        <div class="content">{{detail.yearInterest}}%</div>
                    </div>
                    <div class="child">
                        <div class="name">产品介绍：</div>
                        <div class="content super_p" v-html="detail.productIntro"></div>
                    </div>
                    <div class="childMulti">
                        <div class="name">贷款须知：</div>
                        <ul>
                            <li class="content" v-for="(item,index) in detail.loanKnown" :key="index" >
                                {{item.sort}}. {{item.content}}
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,index) in detail.fileList" :key="index"><span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i></li>
                        </ul>
                        
                    </div> -->
                    <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detail.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                                </li>
                            </ul>
                     </div>
                </div>
            </el-dialog>
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">账号信息</div>
                        <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{info.user.userName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{info.user.userTypeName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{info.user.realName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{info.user.email}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{info.user.contactAddress}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{info.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{info.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{info.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{info.applyRemark}}</div>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,index) in info.fileList" :key="index"><span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i></li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{info.createTime}}</div>
                        </div>
                    </div>
                    <div class="boxChild" v-if="tab==='2'">
                        <div class="basisTitle">审核结果</div>
                        <div class="child">
                            <div class="name">审核结果：</div>
                            <div class="content">{{info.checkStatusValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核人：</div>
                            <div class="content">{{info.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{info.updateTime}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{info.checkExplanation}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 更新进度 -->
            <el-dialog
                title="更新进度"
                :visible.sync="dialogUpdate"
                width="30%">
                <div class="forms">
                <div class="child">
                    <div class="name"><span>*</span>贷款进度：</div>
                    <el-select v-model="sendInfoTwos.rate" @change="sendInfoTwos.amount = ''">
                      <el-option value="" label="请选择" />
                      <el-option v-for="item in proList" :key="item.value" :label="item.name" :value="item.value" />
                    </el-select>
                </div>
                <div class="error" v-if="errors['sendInfoTwos.rate']">错误提示：{{errors['sendInfoTwos.rate']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>是否已放款：</div>
                    <el-radio-group v-model="sendInfoTwos.isloan" @change="changeIsloan">
                      <el-radio :label="1">否</el-radio>
                      <el-radio :label="2">是，放款金额（万元）<el-input v-model="sendInfoTwos.amount" style="width: 133px;" /></el-radio>
                    </el-radio-group>
                </div>
                <div v-show="errors['sendInfoTwos.isloan']" class="error">*{{ errors['sendInfoTwos.isloan'] }}</div>
                <div v-show="errors['sendInfoTwos.amount']" class="error">*{{ errors['sendInfoTwos.amount'] }}</div>
                <div class="childTextarea">
                    <div class="name">说明：</div>
                    <div class="content"><el-input type="textarea" v-model="sendInfoTwos.dealWithRemark" show-word-limit maxlength="200"></el-input></div>
                </div>
                <div class="doubleBtn">
                    <el-button size="small"  type="primary" @click="submit(2)">确认</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
                </div>
            </el-dialog>
            <!-- 审核 -->
            <el-dialog
                title="更改审核"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                <div class="child">
                    <div class="name"><span>*</span>审核结果：</div>
                    <el-radio-group v-model="sendInfoTwo.checkStatus">
                        <el-radio :label="item.value" v-for="(item,index) in statusList" :key="index">{{item.name}}</el-radio>
                    </el-radio-group>
                </div>
                <div class="error" v-if="errors['sendInfoTwo.checkStatus']">错误提示：{{errors['sendInfoTwo.checkStatus']}}</div>
                <div class="childTextarea">
                    <div class="name">说明：</div>
                    <div class="content"><el-input type="textarea" v-model="sendInfoTwo.checkRemark" show-word-limit maxlength="200"></el-input></div>
                </div>
                <div class="doubleBtn">
                    <el-button  size="small" type="primary" @click="submit(1)">确认</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
                </div>
            </el-dialog>
            <!-- 更改产品 -->
            <el-dialog title="更改产品" :visible.sync="dialogTableVisible" width="50%">
                <div class="retrieve" ref="condition">
                    <div class="left">
                        <div class="child">
                            <el-input size="small" v-model="prod.id" placeholder="债权产品ID" style="width:135px"></el-input>
                        </div>
                        <div class="child">
                            <el-input size="small" v-model="prod.debtProductName" placeholder="产品名称" style="width:135px"></el-input>
                        </div>
                        <div class="child">
                            <el-select  v-model="prod.loanType" placeholder="贷款类型" size="small" clearable @change="changeLoan">
                                <el-option
                                v-for="item in loanType"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value" >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="child">
                            <el-input size="small" v-model="prod.bankName" placeholder="银行名称" style="width:135px"></el-input>
                        </div>
                        <el-button type="primary" size="small" @click="onSearch" class="retrievalBtn">查询</el-button>
                        <el-button size="small" @click="onResets" class="retrievalBtn">重置</el-button>
                    </div>
                </div>
                <el-table :data="gridData" ref="gridData" style="width:100%" fit @selection-change="handleSelectionChange" v-loading="gridLoading"
                element-loading-text="请求中......">
                 <el-table-column type="selection" width="55"/>
                  <el-table-column property="id" label="债权产品ID"></el-table-column>
                  <el-table-column property="debtProductName" label="产品名称"></el-table-column>
                  <el-table-column property="loanTypeValue" label="贷款类型"></el-table-column>
                  <el-table-column property="bankName" label="银行名称"></el-table-column>
                </el-table>
                <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChanges"
                    @current-change="handleCurrentChanges"
                    :current-page="gridCurrentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="prod.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="gridTotalSize">
                </el-pagination>
            </div>
                <div slot="footer" class="dialog-footer">
                    <div>
                        <span>当前选择：</span>
                        <span v-if="checkProd">债权产品ID：{{checkProd.id}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;产品名称：{{checkProd.debtProductName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;贷款类型：{{checkProd.loanTypeValue}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;银行名称：{{checkProd.bankName}}</span>
                    </div>
                    <div>
                        <el-button size="small" @click="dialogTableVisible = false">取 消</el-button>
                    <el-button size="small"  type="primary" @click="onUpdateSub">确 定</el-button>
                    </div>
                  </div>
              </el-dialog>
        </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
// import breadcrumb from '../../components/breadcrumb';
import Regular from "@/mixins/regular.js";
import {onDownload} from "@/utils/common";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
          loading:false,
          dialogUpdate:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
                },{
                value: '4',
                label: '债权产品名称'
                },{
                value: '5',
                label: '申请人姓名'
                }
            ],//检索下拉
            statusList:[],//审核结果
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                checkStatus:'',//审核结果
                endDate:null,//结束时间
                startDate:null,//开始时间
                id:null,//申请id
                userName:null,//账号
                name:null,//姓名
                debtProductName:'',//债权产品名称
                applicant:null,//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
                rate: void 0
            },//检索提交数据
            totalSize:null,//总条数
            tab:'1',//选项卡
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogDetail:false,//表格内详情弹出层
            detail:{},//产品明细
            dialogInfo:false,//查看明细弹出层
            info:{
                user:{
                    userName:'',
                    userTypeName:"",
                    realName:"",
                    email:"",
                    contactAddress:"",
                },
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                checkStatusValue:"",
                modifyUserName:"",
                checkExplanation:""
            },//查看明细
            dialogAudit:false,//审核弹出层
            sendInfoTwo:{
                applyId:'',//审核id
                checkStatus:null,//审核结果
                checkRemark:'',//说明
            },//审核提交数据
            sendInfoTwos:{
                applyId: '', // 客户申请ID
                rate: '', // 贷款进度
                isloan: void 0, // 是否放款:
                amount: '', // 放款金额
                dealWithRemark: '' // 说明
            },//更新提交数据
            proList:[],
            dialogTableVisible:false,
            loanType:[],
            gridData: [],
            multipleSelection:[],
            gridCurrentPage:1,
            gridTotalSize:0,
            gridLoading:false,
            currentProd: void 0,
            prod:{
                id:void 0,
                debtProductName:void 0,
                loanType: void 0,
                loanTypeValue: void 0,
                bankName: void 0,
                status:1,
                currentPage:1,//当前页
                pageSize:10,//页条数
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
        checkProd(){
            return this.multipleSelection && this.multipleSelection.length !== 0?this.multipleSelection[0]: void 0
        }
    },
    vuerify: {
        'sendInfoTwo.checkStatus':{
            test:function(val){
                if(val){
                    return true;
                }else{
                  if(this.dialogUpdate) return true
                  else  return false;
                }
            },
            message:'选择审核结果'
        },
        'sendInfoTwos.rate': {
          test(val) {
            if (val) {
              return true
            } else {
              if(this.dialogAudit) return true
              return false
            }
          },
          message: '选择贷款进度'
        },
    'sendInfoTwos.amount': {
      test(val) {
        if (this.sendInfoTwos.rate === '1' && !val) {
          if(this.dialogAudit) return true
          else return false
        } else {
          
          return true
        }
      },
      message: '输入放款金额'
    },
    'sendInfoTwos.dealWithRemark': {
      test(val) {
        if (this.sendInfoTwos.rate === '-1' && !val) {
          if(this.dialogAudit) return true
          else return false
        } else {
          return true
        }
      },
      message: '请填写说明'
    }
    },
    methods:{
        changeLoan(val){
            const list = this.loanType.filter(item=>item.value === val)
            if(list && list.length !== 0) this.prod.loanTypeValue = list[0].name
        },
        async getGrid(){
            try{
            this.gridLoading = true
            const {code,data,msg} = await this.$axiosc.get('backstage/debt/financing/all/list',{params:this.prod})
            if(code === 200) {
                this.gridData=data.content || [];
                this.gridTotalSize=data.totalElements || 0;
                this.gridLoading = false
            }
            else {this.gridData = [];this.gridLoading = false}
        }catch(e){
            this.gridLoading = false
        }
        },
        onUpdateSub(){
            const that =this;
            that.$confirm('确认是否更换？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
				// 更换todu
                const param = {
                    id:that.currentProd.id,
                    deptId:that.checkProd.id
                }
                this.$axiosc.post('/backstage/apply/audited/change',this.$qs.stringify(param)).then(res=>{
                if(res.code == 200){
                    that.dialogTableVisible = false
                    this.getData()
                    this.$message({
                        type: 'success',
                        message: '更改产品成功'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: '更改产品失败'
                    });
                }
            })
                
               
            }).catch(() => {});
        },
        updateProd(row){
            this.currentProd = row
            this.dialogTableVisible = true
            this.getGrid()
        },
        handleSelectionChange(val) {
            if(val.length > 1){
                this.$refs.gridData.clearSelection()
                this.$refs.gridData.toggleRowSelection(val.pop());
            }else this.multipleSelection = val;
      },
     onSearch(){
        this.prod.currentPage = 1
        this.getGrid()
     },
     onResets(){
        const param = {
                id:void 0,
                debtProductName:void 0,
                loanType: void 0,
                loanTypeValue: void 0,
                bankName: void 0,
                status:1,
                currentPage:1,//当前页
                pageSize:10,//页条数
        }
        this.prod = Object.assign(this.prod,param)
        if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
        this.getGrid()
     },
     async onReset(){
            this.getSelect=void 0;//检索下拉的值
            this.getValue=void 0;//检索输入框的值
            this.dateS=[];//日期
            this.sendInfoOne.currentPage=1;//当前页
            this.sendInfoOne.pageSize=20;//页条数
            this.sendInfoOne.checkStatus=void 0;//审核结果
            this.sendInfoOne.endDate=void 0;//结束时间
            this.sendInfoOne.startDate=void 0;//开始时间
            this.sendInfoOne.id=void 0;//申请id
            this.sendInfoOne.userName=void 0;//账号
            this.sendInfoOne.name=void 0;//姓名
            this.sendInfoOne.debtProductName=void 0;//债权产品名称
            this.sendInfoOne.applicant=void 0;//申请人姓名
            this.sendInfoOne.rate = void 0
            this.totalSize=void 0;//总页码
            this.tableData= void 0;
            if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
            await this.getData();
      },
      //下载附件
        downLoad:function({fileName,filePath}){
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
          // 切换选择时清空金额
        changeIsloan() {
          this.sendInfoTwos.amount = ''
        },
        //获取字典
        async getDic(){
            const res = await this.$axiosz.get('backstage/sysDict/CHECK_STATUS')
            if(res.code==200){
                    res.data.shift()
                    this.statusList=res.data && res.data.legnth !== 0?res.data.filter(item=>item.value === '-1' || item.value === '1') : [{name:'通过',value:'1'},{name:'不通过',value:'-1'}];
            }
            this.$axiosz.get('backstage/sysDict/isShow/LOAN_TYPE').then((r)=>{ //贷款类型
                if(r.code==200){
                    this.loanType = r.data
                }
            })
            this.$axiosz.get('backstage/sysDict/isShow/LOAN_RATE').then((r) => {
              // 更新进度
              if (r.code === 200) {
                this.proList = r.data
              }
            })
            // this.proList = [{name:'处理中',value:'0'},{name:'发放成功',value:'1'},{name:'贷款失败',value:'-1'}]
        },
        //获取数据
       async getData(){
      this.loading = true
			this.sendInfoOne.id=null;
			this.sendInfoOne.userName=null;
			this.sendInfoOne.name=null;
			this.sendInfoOne.debtProductName='';
			this.sendInfoOne.applicant=null;
            if(this.dateS&&this.dateS.length>0){
                 this.sendInfoOne.startDate=this.dateS[0];
                 this.sendInfoOne.endDate=this.dateS[1];
             }else{
                 this.sendInfoOne.startDate=null;
                 this.sendInfoOne.endDate=null;
             }
            if(this.getSelect=='1'){ //申请id
				if(!Regular.numPint.test(this.getValue)){
          this.loading = false
					this.$alert('申请ID为正整数');
					return
				}else{
					this.sendInfoOne.id=this.getValue;
				}
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='4'){ //债权产品名称
                this.sendInfoOne.debtProductName=this.getValue;
            }else if(this.getSelect=='5'){ //申请人姓名
                this.sendInfoOne.applicant=this.getValue;
            }
            let url='';
            if(this.tab==='1'){
                url='backstage/apply/audit/list';
            }else{
                url='backstage/apply/audited/list';
            }
            const {code,data,msg} = await this.$axiosc.get(url,{params:this.sendInfoOne})
            this.loading = false
            if(code==200){
                this.tableData=data.content || [];
                this.totalSize=data.totalElements || 0;
            }else{
                this.$alert(msg)
            }
        },
        // 切换选项啦
        async changeTab(tab){
            this.tab=tab.name;
            
            await this.onReset();
        },
        //查看表格内详情
         viewDetails(row){
           this.$router.push({path: `/auditsManagement/applicationDebt/company/detail/${this.tab}`, query: {id: row.loanId, index: '/auditsManagement/applicationDebt'},param:{type:this.tab}})
           
            // const that = this
            // const {code,data,msg} = await this.$axiosc.get('backstage/debt/financing/details/'+row.loanId)
            // if(code==200){
            //         that.detail=data || [];
            //         that.dialogDetail=true;
            //     }else{
            //         that.$alert(msg)
            //     }
        },
        //表格排序事件
        async sortChange({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            await this.getData();
        },
        //分页功能模块
        //切换每页显示条数
        async handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
           await this.getData();
        },
        //切换页码
        async handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            await this.getData();
        },
        async handleSizeChanges(val) {
            this.prod.pageSize=val;
           await this.getGrid();
        },
        //切换页码
        async handleCurrentChanges(val) {
            this.prod.currentPage=val;
            await this.getGrid();
        },
        //查看明细
        async check(row){
          this.$router.push({path: `/auditsManagement/applicationDebt/detail/${this.tab}`, query: {id: row.id, index: '/auditsManagement/applicationDebt'},param:{type:this.tab}})
            // const that = this
            // const {data,code,msg} = await that.$axiosc.get('backstage/apply/details/'+row.id)
            // if(code==200){
            //         that.info=data || []; 
            //         that.dialogInfo=true;
            //     }else{
            //         that.$alert(msg)
            //     }
        },
        //打开审核
        audit:function(row){
            this.$vuerify.clear();
            this.sendInfoTwo.applyId=row.id;
            this.sendInfoTwo.checkStatus = '1'
            this.dialogAudit=true;
        },
        // 打开更新进度
        update(row){
          this.sendInfoTwos.rate = ''
          this.$axiosc.get('/backstage/apply/debtApply/details/' + row.id).then((r) => {
            if (r.code === 200) {
              this.$vuerify.clear()
              this.dialogUpdate=true;
              this.sendInfoTwos.applyId = row.id
              if (this.proList && r.data.rate) {
                this.sendInfoTwos.rate = r.data.rate + '' // 贷款进度
              }
              this.$vuerify.clear()
              if (r.data.amount > 0) {
                // 已放款
                this.sendInfoTwos.isloan = 2
              } else {
                // 未放款
                this.sendInfoTwos.isloan = 1
              }
              this.sendInfoTwos.amount = r.data.amount // 放款金额
              this.sendInfoTwos.dealWithRemark = r.data.dealWithRemark // 说明
              
            } else {
              this.$alert(r.msg)
            }
          })
          
        },
       
        //取消按钮
        cancel:function(){
            this.dialogAudit=false;
            this.dialogUpdate = false
            this.sendInfoTwo.applyId=null;//id
            this.sendInfoTwo.checkStatus=null;//审核结果
            this.sendInfoTwo.checkRemark=null;//说明
            this.sendInfoTwos.applyId =  void 0
            this.sendInfoTwos.rate = void 0
            this.sendInfoTwos.isloan  = void 0
            this.sendInfoTwos.amount = void 0
            this.sendInfoTwos.dealWithRemark =void 0
        },
        //保存按钮
        async submit(type){
            const that = this
            that.$vuerify.clear();
            if(that.$vuerify.check()){
                const {code,msg} = type === 1?await that.$axiosc.put('backstage/common/applyReview',that.$qs.stringify(that.sendInfoTwo)):await that.$axiosc.put('/backstage/apply/debtApply/debtUpdateProgress',that.$qs.stringify(that.sendInfoTwos))
                if(code==200){
                        that.$message({
                            message: type === 1?'审核成功！':'更新成功',
                            type: 'success'
                        });
                        that.dialogAudit=false;
                        that.dialogUpdate = false
                       await that.getData();
                    }else{
                        that.$alert(msg)
                    }
            }
        }
    },
    mounted(){
       const that = this
        that.getDic();
        // 待审核
        if(that.authorities.indexOf('sys:permission:background:debt:apply:unAudit')==-1){
          that.tab='2'
        }
        // 待审核 和审核记录存在一个
        if(that.authorities.indexOf('sys:permission:background:debt:apply:unAudit')!=-1||that.authorities.indexOf('sys:permission:background:debt:apply:audit')!=-1){
          that.getData();
        }
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 100
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 100
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.retrieve{
  margin-bottom:10px !important;
}
.dialog-footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    div{
        &:first-child{
            text-align: left;
            max-width:80%;
            span{
                display: block;
                line-height: 20px;
            }
        }
    }
}
::v-deep .el-table__header {
    .el-checkbox {
      display: none;
    }
  }

</style>